import { render, staticRenderFns } from "./BlackFridayModal.vue?vue&type=template&id=7ff0a0cf&scoped=true&"
import script from "./BlackFridayModal.vue?vue&type=script&lang=js&"
export * from "./BlackFridayModal.vue?vue&type=script&lang=js&"
import style0 from "./BlackFridayModal.vue?vue&type=style&index=0&id=7ff0a0cf&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff0a0cf",
  null
  
)

export default component.exports